'use strict';

var ReferencesButtonsDirective = function ReferencesButtonsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/references-buttons.html'),
    scope: {
      items: '=',
      toggle: '&'
    }
  };
};
ReferencesButtonsDirective.$inject = [];
module.exports = ReferencesButtonsDirective;